const $ = typeof window !== 'undefined' && jQuery;

const DOM_ATTRIBUTE_NODE = 2;

const appendAttrDataPrefix = function (node, key) {
    return "fvAttr_" + node.nodeName + "_" + key;
};


export const setNodeData = function (node, key, value) {
    if (!$) { return; }

    if (node && node.nodeType === DOM_ATTRIBUTE_NODE) {
        // $.data() doesn't seem to allow attaching data to an attribute node,
        // so we'll attach it to the attribute's owner element
        setNodeData(
            node.ownerElement,
            appendAttrDataPrefix(node, key),
            value,
        );
    } else {
        $.data(node, key, value);
    }
};

export const getNodeData = function (node, key) {
    if (!$) { return null; }

    if (node && node.nodeType === DOM_ATTRIBUTE_NODE) {
        return getNodeData(
            node.ownerElement,
            appendAttrDataPrefix(node, key),
        );
    } else {
        return $.data(node, key);
    }
};
